"use strict";

var _interopRequireDefault = require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
var _regenerator2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _objectSpread2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _waves = _interopRequireDefault(require("@/directive/waves"));
var _common = require("@/api/common");
var _anchorReport = require("@/api/anchorReport");
var _vuex = require("vuex");
var _utils = require("@/utils");
var _default = exports.default = {
  components: {
    Pagination: _Pagination.default
  },
  directives: {
    waves: _waves.default
  },
  filters: {
    rateFilter: function rateFilter(val) {
      return (val * 100).toFixed(2);
    }
  },
  data: function data() {
    return {
      times: [],
      listLoading: false,
      typeList: [{
        label: '留存率',
        value: 0
      }, {
        label: '留存付费人数',
        value: 1
      }, {
        label: '留存实充金额',
        value: 2
      }, {
        label: '留存付费率',
        value: 3
      }, {
        label: '留存ARPPU',
        value: 4
      }],
      appNames: [],
      list: [],
      called: {},
      total: 0,
      listQuery: {
        startTime: '',
        endTime: '',
        page: 1,
        size: 30,
        app_name: '',
        type: 0
      }
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['roles', 'brandList'])),
  watch: {
    times: function times(val) {
      this.listQuery.startTime = '';
      this.listQuery.endTime = '';
      if (val) {
        this.listQuery.startTime = val[0];
        this.listQuery.endTime = val[1];
      }
    }
  },
  created: function created() {
    if (this.roles.includes('channel')) this.channelApps();
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    getList: function () {
      var _getList = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var _yield$retainedUserRe, code, data;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.listLoading = true;
              _context.n = 1;
              return (0, _anchorReport.retainedUserReportList)(this.listQuery);
            case 1:
              _yield$retainedUserRe = _context.v;
              code = _yield$retainedUserRe.code;
              data = _yield$retainedUserRe.data;
              if (code === 0) {
                this.buildList(data.list, this.listQuery.type);
                this.total = data.total;
              }
              this.listLoading = false;
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }(),
    channelApps: function () {
      var _channelApps = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var _yield$getChannelApps, code, data;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return (0, _common.getChannelApps)(this.listQuery);
            case 1:
              _yield$getChannelApps = _context2.v;
              code = _yield$getChannelApps.code;
              data = _yield$getChannelApps.data;
              if (code === 0) {
                this.appNames = data;
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function channelApps() {
        return _channelApps.apply(this, arguments);
      }
      return channelApps;
    }(),
    buildList: function () {
      var _buildList = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3(list, type) {
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              list.map(function (item) {
                var keys = Object.keys(item);
                for (var i = 0; i < keys.length; i++) {
                  if (keys[i].indexOf('retainedDay') !== -1) {
                    if (type === 0 || type === 3) {
                      item[keys[i]] = item[keys[i]] && (0, _utils.customToFixed)(item[keys[i]] / item.new_users * 100, 2) + '%' || '';
                    } else if (type === 1) {
                      item[keys[i]] = item[keys[i]] || '';
                    } else if (type === 2) {
                      item[keys[i]] = item[keys[i]] && (0, _utils.customToFixed)(item[keys[i]] / 100, 2) || '';
                    } else if (type === 4) {
                      if (keys[i].indexOf('pay_retainedDay') !== -1) {
                        var retainedDayKey = keys[i].replace('pay_', '');
                        item[retainedDayKey] = item[retainedDayKey] && (0, _utils.customToFixed)(item[retainedDayKey] / item[keys[i]] / 100, 2) || '';
                      }
                    }
                  }
                }
                return item;
              });
              this.list = list;
            case 1:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function buildList(_x, _x2) {
        return _buildList.apply(this, arguments);
      }
      return buildList;
    }(),
    handleFilter: function () {
      var _handleFilter = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4() {
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              this.listQuery.page = 1;
              this.getList();
            case 1:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function handleFilter() {
        return _handleFilter.apply(this, arguments);
      }
      return handleFilter;
    }(),
    customToFixed: _utils.customToFixed
  }
};